const learnMetaData = {
	"/learn/introduction": {
		isPractice: false,
		learnTitle: "Introduction to finger placement",
		subText: "Let's take a look at what makes a semitone and a whole tone and how they affect your finger placement!",
		learnData: [
      {
        learnImg: '', 
				imgTitle: '',
				texts: [
					"Do you know why sometimes on your left hand, you have to place two fingers tightly next to each other without any space in between them, but sometimes the same fingers are placed apart?",
          "Have you ever heard of SEMITONE or WHOLE TONE?"
				]
      },
      {
        learnImg: '', 
				imgTitle: '',
				texts: [
          "If no, let's read on...... ",
          "Where we place our fingers has everthing to do with distances between two notes. We call this distance INTERVAL.", 
				]
      },
      {
        learnImg: '', 
				imgTitle: '',
				texts: [
          "Let me begin with two fingers WITH space in between them:",
					"Sometimes your two fingers are placed apart and the space in between the fingers is about the size of another finger.",
          "If this space is about the size of 1 finger, it means the space is big enought to fit in 1 note...",
          "If this space is about the size of 2 fingers, then it can fit in 2 notes...",
          "If this space is about the size of 3 fingers, then...",
          "Ok, you got the gist!",
          "We call this space, or interval, big enough to fit in ONE note - a WHOLE TONE." 
				]
      },
      {
        learnImg: '', 
				imgTitle: '',
				texts: [
          "Now, let's talk about two fingers WITHOUT space:",
					"Sometimes you have to place two fingers tightly next to each other without any space in between. You cannot fit in another finger which means there is no room for another note.",
          "We call this interval which you cannot fit any note in between - a SEMITONE" 
				]
      },
			{
				learnImg: '/assets/images/learn/piano_keyboard_even_more_space.png', 
				imgTitle: 'Piano keyboard showing whole-tones and semitones',
				texts: [
					"Now, let's look at this piano keyboard:",
          "Please look at all the white keys and their relationships with other white keys next to each other...",
					'Have you noticed that some white keys have a black key in between themselves but others not?', 
          "So what's the difference?"
				]
			},
      {
				learnImg: '/assets/images/learn/piano_keyboard_even_more_space.png', 
				imgTitle: 'Piano keyboard showing whole-tones and semitones',
				texts: [
          'Take D and E for example, there is a black key between them and that black key plays a note called D♯ or E♭.',
					'Since there is a note in between D and E, therefore the interval between these two notes is a WHOLE TONE.',
					'However, E and F do not have a black key in between them, neither do B and C.',
          "This means the interval for E and F is a SEMITONE! So is the interval of B and C!"
				]
			},
      {
        learnImg: '', 
				imgTitle: '',
				texts: [
          "So, when all the notes are natural (♮), the only intervals that make a SEMITONE is between E and F, and B and C.",
          "But how do we remember ?",
          "Well, I try to remember them this way:",
          "Eat Fudge (E F) and Banana Cake! (B C)",
          "You can never go wrong with good desserts...."
				]
      },
			{
				learnImg: '/assets/images/learn/D_string_example_natural.png', 
				imgTitle: 'D string example - all natural',
				texts: [
          "Ok, ok, let's go back to the violin....",
          "We are now looking at these 5 notes on the D string:",
          "D - E - F - G - A",
          "Since E and F makes a SEMITONE, you can see that E and F (1st and 2nd finger) are placed together WITHOUT any gap in between them.",
					"The rest of the notes make WHOLE TONE intervals with their next door neighbours, therefore they have a gap in between them."
				]
			},
			{
				learnImg: '/assets/images/learn/D_string_example_F_sharp.png', 
				imgTitle: 'D string example - F#',
				texts: [
					"But now look at the F, it has become sharp (♯)! We have to move F higher!", 
          "Since F is no longer natural (♮), it no longer is a SEMITONE with E. Instead, F♯ is a SEMITONE to G!", 
					'So now the spacings between the 1st, 2nd and 3rd fingers have changed!', 
					'We now have a space between E (1st finger) and F♯ (2nd finger) because they form a WHOLE TONE, but there is no space between F♯ and G (3rd finger) because they form a SEMITONE!'
				]
			},
			{
				learnImg: '/assets/images/learn/G_string_example_natural.png', 
				imgTitle: 'G string example - all natural',
				texts: [
					"Let's take a look at another example! We are now looking at 5 notes on our lowest string - the G string:", 
          "G - A - B - C - D",
					'Since B and C (Banana Cake) makes a SEMITONE, therefore there is no space in between the 2nd and 3rd finger.',
          "The rest of the notes make WHOLE TONE intervals with their next door neighbours therefore they do have a gap in between them."
				]
			},
			{
				learnImg: '/assets/images/learn/G_string_example_B_flat.png', 
				imgTitle: 'G string example - Bb',
				texts: [
          "But now look at the B on this string, it has become flat (♭) and we have to move it lower!",
					"Since B is no longer natural (♮), it no longer is a SEMITONE with C. Instead, B♭ is a SEMITONE to A!",
          "We now have no space between A (1st finger) and B♭ (2nd finger) because they make a SEMITONE, but there is a space between B♭ and C (3rd finger) as they make a WHOLE TONE!"  
				]
			},
			{
				learnImg: '/assets/images/learn/E_string_example_natural.png', 
				imgTitle: 'E string example - all natural',
				texts: [
					"Hang on, we now have a very different situation here on the E string, our highest string!",
          "E - F - G - A - B",
          "A SEMITONE lies in between the open E string and the 1st finger F!", 
					"So there is NO SPACE in between the open string and the 1st finger note?", 
          "How do we play this?",
					"In fact, there is a space in between the open strings and where you normally place your 1st finger notes. F♮ is located in this space and all you have to do is lower your 1st finger!",
          "Do you see in this photo that E (open) and F (1st finger) is next to each other, but in previous photos there's a gap in between the open strings and the 1st finger notes?"
				]
			},
			{
				learnImg: '/assets/images/learn/E_string_example_F_sharp.png', 
				imgTitle: 'E string example - F#',
				texts: [
					"And if F is sharp (♯), the position of the 1st finger would then be back at the usual place.", 
					"F♯ also makes a SEMITONE with the 2nd finger G!"
				]
			},
			{
				learnImg: '/assets/images/learn/C_major_all_strings.png', 
				imgTitle: 'C Major notes and finger pattern',
				texts: [
					"In short, this is where all the notes are on the fingerboard in the First Position when there is no sharp (♯) nor flat (♭) in your music!", 
          "Please take a look at where all the SEMITONES are across the strings!"
				]
			},
			{
				learnImg: '', 
				imgTitle: '',
				texts: [
					"Lastly, you can learn more notes with sharps and flats and where to find them on the fingerboard in the LEARN section from the Main Menu. They are grouped by keys up to 4 sharps and 4 flats.",
					"But please do not just memorize patterns. It is far more beneficial to always know what notes you are playing and where to find them on the fingerboard as it will help you sightread and learn music more easily!", 
          "And knowing where SEMITONES and WHOLE TONES are can help you play more in tune.",
          "If you are not familiar with note names, the FLASHCARDS section may be helpful.",
					"You can also practice your knowledge by playing the interactive games in the PLAY & PRACTICE section! Check them out from the Main Menu!"
				]
			},
		]
	},
  "/learn/c_major": {
    isPractice: false,
    learnTitle: "Learn: C Major",
    subText: "When everything is natural! There is no sharp nor flat!",
    learnData: [
      {
        learnImg: '/assets/images/learn/C_major_all_strings.png', 
        imgTitle: 'C Major notes and finger pattern',
        texts: [
          'C Major is the key where there is no sharp nor flat on any note!',
          'We must remember where the semitones are! They are between E and F, and also B and C!',
          'To play these intervals, you must put those fingers together!'
        ]
      },
    ]
  },
  "/learn/g_major": {
    isPractice: false,
    learnTitle: "Learn: G Major",
    subText: "When we have one sharp: F♯",
    learnData: [
			{
        learnImg: '/assets/images/learnKeys/G_major_with_key.png', 
        imgTitle: 'G Major with key signature',
        texts: [
          "If you have one sharp sign (♯) next to the treble clef and that ♯ sign looks like it is sitting on the high F position, this means all the Fs in your music are sharp! ", 
					"You will find two F♯ notes in the first position on your violin.",
					"If all the Fs are sharp, this key is called G Major."
        ]
      },
			{
        learnImg: '/assets/images/learnKeys/G_major_without_key.png', 
        imgTitle: 'G Major without key signature',
        texts: [
          "If there is no key signature (no ♯ sign sitting on high F position next to the clef), you will see the ♯ signs next to these notes for G Major!", 
        ]
      },
      {
        learnImg: '/assets/images/learn/G_major_all_strings.png', 
        imgTitle: 'G Major notes and finger pattern',
        texts: [
          'This shows all the notes for G Major in the first position on your violin and where they are located on the fingerboard.',
					"You can find F♯ on D string and E string.",
					"Remember, F is now sharp so it is no longer a semitone to E. It is now semitone to G!"
        ]
      },
    ]
  },
  "/learn/f_major": {
    isPractice: false,
    learnTitle: "Learn: F Major",
    subText: "When we have one flat: B♭",
    learnData: [
			{
        learnImg: '/assets/images/learnKeys/F_major_with_key.png', 
        imgTitle: 'F Major with key signature',
        texts: [
          "If you have one flat sign (♭) next to the treble clef and that ♭ sign looks like it is sitting on the same position as B, this means all the Bs in your music are flat! ", 
					"You will find three B♭ notes in the first position on your violin.",
					"If all the Bs are flat, this key is called F Major.",
        ]
      },
			{
        learnImg: '/assets/images/learnKeys/F_major_without_key.png', 
        imgTitle: 'F Major without key signature',
        texts: [
          "If there is no key signature (no ♭ sign sitting on B position), you will see the ♭ signs next to these notes for F Major!", 
        ]
      },
      {
        learnImg: '/assets/images/learn/F_major_all_strings.png', 
        imgTitle: 'F Major notes and finger pattern',
        texts: [
          'This shows all the notes for F Major in the first position on your violin and where they are located on the fingerboard.',
					"You can find B♭ notes on G, A string and E string.",
					"Remember, B is now flat so it is no longer a semitone to C. It is now semitone to A!"
        ]
      },
    ]
  },
  "/learn/d_major": {
    isPractice: false,
    learnTitle: "Learn: D Major",
    subText: "When we have two sharps: F♯ and C♯",
    learnData: [
			{
        learnImg: '/assets/images/learnKeys/D_major_with_key.png', 
        imgTitle: 'D Major with key signature',
        texts: [
          "If your music has two sharp signs (♯) next to the treble clef, the first one must be F and the second one must be C!", 
					"This means all the Fs and Cs in your music are sharp! You will find two F♯ notes and two C♯ notes in the first position on your violin.",
					"If all the Fs and Cs are sharp, this key is called D Major!"
        ]
      },
			{
        learnImg: '/assets/images/learnKeys/D_major_without_key.png', 
        imgTitle: 'G Major without key signature',
        texts: [
          "If there is no key signature (no ♯ signs next to the clef), you will see ♯ signs next to these notes for D Major!", 
        ]
      },
      {
        learnImg: '/assets/images/learn/D_major_all_strings.png', 
        imgTitle: 'D Major notes and finger pattern',
        texts: [
					'This shows all the notes for D Major in the first position on your violin and where they are located on the fingerboard.',
					"You can find F♯ notes on D and E strings, and C♯ notes on G and A strings.",
					"Remember, like G Major, F is sharp so it is no longer a semitone to E but semitone to G! C is also sharp so it is now semitone to D!",
					"Take a look at the C♯ on the G string, it is now moved higher, position right next to the 4th finger D!"
        ]
      },
    ]
  },
  "/learn/b_flat_major": {
    isPractice: false,
    learnTitle: "Learn: B♭ Major",
    subText: "When we have two flats: B♭ and E♭!",
    learnData: [
			{
        learnImg: '/assets/images/learnKeys/Bb_major_with_key.png', 
        imgTitle: 'B♭ Major with key signature',
        texts: [
          "If your music has two flat signs (♭) next to the treble clef, the first one must be B and the second one must be E!", 
					"This means all the Bs and Es in your music are flat! You will find three B♭ notes and two E♭ notes in the first position on your violin.",
					"If all the Bs and Es are flat, this key is called B♭ Major!"
        ]
      },
			{
        learnImg: '/assets/images/learnKeys/Bb_major_without_key.png', 
        imgTitle: 'B♭ Major without key signature',
        texts: [
          "If there is no key signature (no ♭ signs next to the clef), you will then see the ♭ signs next to these notes for B♭ Major!", 
        ]
      },
      {
        learnImg: '/assets/images/learn/B_flat_major_all_strings.png', 
        imgTitle: 'B♭ Major notes and finger pattern',
        texts: [
					'This shows all the notes for B♭ Major in the first position on your violin and where they are located on the fingerboard.',
					"You can find B♭ notes on G, A string and E string, and E♭ notes on D and A string.",
					"Watch out! E is now flat so you can no longer use open E! To play E♭ on this register, you can use 4th finger on the A string, position it close to 3rd finger D!"
        ]
      },
    ]
  },
  "/learn/a_major": {
    isPractice: false,
    learnTitle: "Learn: A Major",
    subText: "When we have three sharps: F♯, C♯, and G♯",
    learnData: [
			{
        learnImg: '/assets/images/learnKeys/A_major_with_key.png', 
        imgTitle: 'A Major with key signature',
        texts: [
          "If your music has three sharp signs (♯) next to the treble clef, they are F, C and G!", 
					"This means all the Fs, Cs, and Gs in your music are sharp! You will find two F♯ nots, two C♯ notes, and three G♯ notes in the first position on your violin.",
					"If all the Fs, Cs, and Gs are sharp, this key is called A Major!"
        ]
      },
			{
        learnImg: '/assets/images/learnKeys/A_major_without_key.png', 
        imgTitle: 'A Major without key signature',
        texts: [
          "If there is no key signature (no ♯ signs next to the clef), you will then see the ♯ signs next to these notes for A Major!", 
        ]
      },
      {
        learnImg: '/assets/images/learn/A_major_all_strings.png', 
        imgTitle: 'A Major notes and finger pattern',
        texts: [
					'This shows all the notes for A Major in the first position on your violin and where they are located on the fingerboard.',
					"You can find F♯ notes on D string E strings, C♯ notes on G and A strings, and G♯ notes on G, D and E strings.",
					"Take a look at the C♯ on the G string and the G♯ note on the D string, they are now moved higher, position right next to the 4th finger note!",
					"The low G is now sharp therefore you can no longer use the open G which can only play G♮. Instead, you can use your 1st finger to play G♯ by moving it lower than the 1st finger A!"
        ]
      },
    ]
  },
  "/learn/e_flat_major": {
    isPractice: false,
    learnTitle: "Learn: E♭ Major",
    subText: "When we have three flats: B♭, E♭, and A♭!",
    learnData: [
			{
        learnImg: '/assets/images/learnKeys/Eb_major_with_key.png', 
        imgTitle: 'E♭ Major with key signature',
        texts: [
          "We now have three flat signs (♭) next to the treble clef, they are B, E and A!",
          "So many flats!", 
					"This means all the Bs, Es, and As in your music are flat! We have now total of eight flat notes in the first position!",
					"If all the Bs, Es, and As are flat, this key is called E♭ Major!"
        ]
      },
			{
        learnImg: '/assets/images/learnKeys/Eb_major_without_key.png', 
        imgTitle: 'E♭ Major without key signature',
        texts: [
          "If there is no key signature (no ♭ signs next to the clef), you will then see the ♭ signs next to these notes for E♭ Major!", 
        ]
      },
      {
        learnImg: '/assets/images/learn/E_flat_major_all_strings.png', 
        imgTitle: 'E♭ Major notes and finger pattern',
        texts: [
          'This shows all the notes for E♭ Major in the first position on your violin and where they are located on the fingerboard.',
					'A is now flat, therefore you will not be able to use open A to play this note. Instead, you can use the 4th finger on D string and position it close to the 3rd finger G.',
					"Please take a look at ALL the 1st finger notes from left to righ: A♭, E♭, B♭, and F - they are all positioned very low.",
          "And three 4th finger notes on D, A, and E strings: A♭, E♭, and B♭ - they are all close to the 3rd fingers except the one on the G string! "
        ]
      },
    ]
  },
  "/learn/e_major": {
    isPractice: false,
    learnTitle: "Learn: E Major",
    subText: "When we have four sharps: F♯, C♯, G♯, and D♯",
		learnData: [
			{
        learnImg: '/assets/images/learnKeys/E_major_with_key.png', 
        imgTitle: 'E Major with key signature',
        texts: [
					"Wow, it's starting to get rather crowded and complicated with sharps!",
          "If your music has four sharp signs (♯) next to the treble clef, they are F, C, G and D!", 
					"This means all the Fs, Cs, Gs, and Ds in your music are sharp!",
					"If all the Fs, Cs, Gs and Ds are sharp, this key is called E Major!",
        ]
      },
			{
        learnImg: '/assets/images/learnKeys/E_major_without_key.png', 
        imgTitle: 'E Major without key signature',
        texts: [
          "If there is no key signature (no ♯ signs next to the clef), you will then see the ♯ signs next to these notes for E Major!", 
        ]
      },
      {
        learnImg: '/assets/images/learn/E_major_all_strings.png', 
        imgTitle: 'E Major notes and finger pattern',
        texts: [
					'This all the notes for E Major in the first position on your violin and where they are located on the fingerboard.',
					"Take a look at the D♯ on the A string, it is now moved higher, position right next to the 4th finger E, just like C♯ on the G string and G♯ on the D string!",
          "We now have three high 3rd finger notes.",
					"And now take a look at the D string, since D is now sharp, you can no longer use open D to play this notes as open D is for D♮. Instead, you can use your 1st finger to play D♯ on D string, it is just below E.",
					"Or, if you are feeling brave, you can also play this D# using 4th finger on the G string, but give it a good stretch to make it higher!",
	
        ]
      },
    ]
  },
  "/learn/a_flat_major": {
    isPractice: false,
    learnTitle: "Learn: A♭ Major",
    subText: "When we have four flats: B♭, E♭, A♭, and D♭!",
    learnData: [
			{
        learnImg: '/assets/images/learnKeys/Ab_major_with_key.png', 
        imgTitle: 'A♭ Major with key signature',
        texts: [
					"We now have 4 flats signs (♭) next to the treble clef!",
          "The 4 flats are B, E, A and D!", 
					"This means all the Bs, Es, As and Ds in your music are flat!",
					"If all the Bs, Es, As and Ds are flat, this key is called A♭ Major."
        ]
      },
			{
        learnImg: '/assets/images/learnKeys/Ab_major_without_key.png', 
        imgTitle: 'A♭ Major without key signature',
        texts: [
          "If there is no key signature (no ♭ signs next to the clef), you will then see the ♭ signs next to these notes for A♭ Major!", 
        ]
      },
      {
        learnImg: '/assets/images/learn/A_flat_major_all_strings.png', 
        imgTitle: 'A♭ Major notes and finger pattern',
        texts: [
					'This shows all the notes for A♭ Major in the first position on your violin and where they are located on the fingerboard.',
					"The only open string you can use to play in this key is the open G. Other open strings like D, A, and E cannot be used because these notes are all flat, therefore you will have use the 4th finger from a lower string and position the 4th finger close to the 3rd finger.",
					"We now also have all 1st finger notes and 4th finger notes in low positions!"
        ]
      },
    ]
  },
  "/learn/3rd_introduction": {
    isPractice: false,
    learnTitle: "Introduction to 3rd Position",
    subText: "What is the 3rd position?",
    learnData: [
			{
        learnImg: '', 
        imgTitle: '',
        texts: [
					"If you are starting to learn to play on the 3rd position, it means that you are entering a whole new level! What a promising violinist you are!",
          "CONGRATULATIONS!",
          "So, what is the 3rd position?"
        ]
      },
			{
        learnImg: '/assets/images/learn/3rd_pos_compare.png', 
        imgTitle: '1st and 3rd positions comparison',
        texts: [
          "Have a look at this photo. On the left we have our usual finger pattern for G Major in the 1st position. On the right, we have a new finger pattern but it is in the 3rd position.",
          "For the 3rd position, it looks like we have moved the entire left hand higher ( closer to you )!",
          "So, how much higher do we have to move to?",
          "If you compare the 3rd position pattern to the 1st position pattern, it looks like in order to play in the 3rd position, you will have to align your first fingers where you normally put your 3rd fingers in the 1st position!",
          "This is why it is called the THIRD POSITION! It is aligned to the 3rd finger line in the 1st position!"

        ]
      },
      {
        learnImg: '', 
        imgTitle: '',
        texts: [
					"Now, a few more questions...",
					"If you align your 1st fingers to where you normally place your 2nd fingers in the 1st position, what do you call this position?",
          "Answer: 2nd position",
          "And what if you move further up and align your 1st fingers to where you noramlly place your 4th fingers in the 1st position, what position do you think this is?",
          "Answer: 4th position",
          "Do you understand how do we name positions now?"
        ]
      },
      {
        learnImg: '', 
        imgTitle: '',
        texts: [
					"So why are we learning to play in the 3rd position? Is it just to be able to play a couple of higher notes which we could not reach in the 1st position?",
					"Well, yes, but there are many more benefits to it...",
          "You see, learning different positions can give you more choices to play the same notes in different places on the violin, and you will be able to choose the position and fingering based on which one makes you play a certain phrase more beautiful, musical, or less difficult.",
        ]
      },
      {
        learnImg: '/assets/images/learn/3rd_pos_compare_music.png', 
        imgTitle: '1st and 3rd positions comparison with music',
        texts: [
          "I'm going to give you this example about position choices...",
          "Please take a look at the musical example on the left. We have a 4 notes, G - E - D - A,  in the 1st position.",
          "If we play it in the 1st position, we would probably use this suggested fingering: starting out with 2nd finger on the E string, follow by a brash open E string, then cross to the A string, then finish with a 4th finger on the D string to avoid a long-held open A.",
          "This is a lot of string crossings just to play 4 notes! Furthermore, we also end up with holding the last note with the 4th finger the D string which nobody likes!",
        ]
      },
      {
        learnImg: '/assets/images/learn/3rd_pos_compare_music.png', 
        imgTitle: '1st and 3rd positions comparison with music',
        texts: [
          "Now, being able to play the same phrase in the 3rd position comes in handy...",
          "If you look a the 3rd position pattern on the right, you will notice that we now can play the first 3 notes of this phrase all on the same string, the A string.",
          "And the cherry on top of the icing is finishing the last note with a 2nd finger on the D string instead of the 4th finger.",
          "This is so much more comfortable...",
          "And the phrase sounds far more melodic and musical if we can play it in the 3rd position!",
        ]
      },
      {
      learnImg: '/assets/images/learn/3rd_pos_compare_D_string.png', 
      imgTitle: '1st and 3rd positions comparison on the D string',
      texts: [
        "However, we do have a new set of fingerings to memorise...",
        "Another example, these 4 notes, G - A - B - C, we have learned to play them in the 1st position with 3rd finger and 4th finger on the D string, and then 1st and 2nd finger on the A string.",
        "However, in the 3rd position they are all on the D string and can be played with fingers 1, 2, 3, 4....",
        "I know, it is quite a lot to remember...."
      ]
      },
      {
        learnImg: '', 
        imgTitle: '',
        texts: [
					"It can be confusing at the start when learning a new position for the first time. You must remember to be very patient with yourself!",
          "Give yourself as much time and commitment to it as you did for the 1st position. But don't worry too much, you will find that it is much easier than you think.",
          "Maybe try to play a simple tune that you know on the 1st position, see if you can play it on the 3rd position. This would be a good start!"
        ]
      },
      {
        learnImg: '/assets/images/learn/3rd_pos_C_major_all_strings.png', 
        imgTitle: 'C Major 3rd position all strings',
        texts: [
					"Lastly, let's not forget about whole tone and semitone spacings!",
          "If you don't have any sharp (♯) nor flat (♭), this is all the notes you can play in the 3rd position in C Major!",
          "In the next part, you can have a look at some patterns if your music has some ♯ or ♭ so you know where to position your fingers!"
        ]
      },

    ]
  },
  "/learn/3rd_introduction_patterns": {
    isPractice: false,
    learnTitle: "Learn: 3rd position patterns in C Major, D Major and F Major",
    subText: "Learn the notes and fingering on the 3rd position, with some sharps and flats",
    learnData: [
			{
        learnImg: '/assets/images/learn/3rd_pos_C_major_all_strings.png', 
        imgTitle: 'C Major 3rd position all strings',
        texts: [
          "In the previous lesson, 'Introduction to 3rd Position', we had a glance of the notes on the 3rd position in C Major, when there is no sharp (♯) nor flat (♭). Here is a quick overview:",
          "B and C makes a semitone, as well as E and F.",
          "Take a look at the finger spacings. It looks like on the G and D strings, we have the 3rd and 4th fingers are placed together without any gap, but on the A and E strings, it is the 2nd and 3rd finger that are placed together." 
        ]
      },
			{
        learnImg: '/assets/images/learn/3rd_pos_D_major_all_strings.png', 
        imgTitle: 'D Major 3rd position all strings',
        texts: [
          "However, if we are to have 2 sharps (♯), F♯ and C♯ for example, making it a D Major....",
          "On the higher strings, A and E strings, the 3rd finger notes are now higher and placed together with the 4th fingers. This makes the alignment of the 3rd fingers across all 4 strings the same line.",  
          "Well, that's simple!",
          "However, things are a little trickier for the lower strings, G and D strings. First of all, we are moving the 1st finger on the G string closer to the 2nd finger, as the C is now sharp (♯) and is a semitone to D.",
          "Furthermore, the both 4th fingers on the G and D strings, F♯ and C♯, need to be moved higher! This is quite a stretch especitally on these lower strings!",
          "How awkward!",
          "I have a trick! Depending on the context of the music and convenience, perhaps you can play the F♯ with a low 1st finger on the D string (dotted circle in grey) instead of playing it with the 4th finger on the G string. And you can do the same for the C♯ on the D string, instead of using a stretched 4th finger, you can play it as a low first finger on the A string!",
          "Do you feel a bit better now?" 
        ]
      },
      {
        learnImg: '/assets/images/learn/3rd_pos_F_major_all_strings.png', 
        imgTitle: 'F Major 3rd position all strings',
        texts: [
          "Lastly, let's have a quick look if you have a flat (♭), a B♭ which makes this a F Major pattern",
          "We will need to lower the 2nd finger on the E string, and the 3rd finger on the D string as they are both B♭ and are semitones to A."
        ]
      },
      {
        learnImg: '', 
        imgTitle: '',
        texts: [
          "That's it for now! I think you get the idea and will adjust your fingers accordingly whenever you have more sharp (♯) or flat (♭) notes!",
          "Remember to be very patient with yourself! If you spend some time learning this new sets of fingerings, you will get the hang of it very quickly!",
          "You can also practice the 3rd position notes in the Practice Section, please take a look at them! Maybe you will find it helpful!",
          "Good luck!"
        ]
      },
      

    ]
  },
}

export default learnMetaData;